export default __webpack_public_path__ + "static/media/check-solid.ecd1011b.svg";